import {quesTermTypes} from '../settingsTypes';

const initialState = {
    allQuestionTerms: [],
    loading: false,
    error: '',
    text: '',
    term:'',
    totalTermsCount: 0,
    allTerms:[],
    errortermdelete:false,
    loadingtermdelete:false,
    successtermupdate: false,
    loadingtermupdate: false,
    errortermupdate:false,
    successtermdelete:false,
    errortermcreate: '',
    successtermcreate: false,
}

export function termReducer(state = initialState, action){
    switch (action.type){
        case quesTermTypes.CREATE_PAGE_REFRESH:
            return {
                ...state,
                allQuestionTerms: [],
                loading: false,
                error: '',
                text: '',
                term:'',
                totalTermsCount:0,
                allTerms:[],
                errortermdelete:false,
                loadingtermdelete:false,
                successtermupdate: false,
                loadingtermupdate: false,
                errortermupdate:false,
                successtermdelete:false,
                errortermcreate: '',
                successtermcreate: false,
            }
        //Term retrieve request sending
        case quesTermTypes.GET_ALL_QUESTION_TERMS:
            return {
                ...state,
                loading: true,
                text: 'Get all the question terms'
            }
        case quesTermTypes.GET_ALL_QUESTION_TERMS_REQUEST:
            return {
                ...state,
                loading: true
            }
        case quesTermTypes.GET_ALL_QUESTION_TERMS_SUCCESS:
            return {
                ...state,
                loading: false,
                allQuestionTerms: action.terms.terms,
                totalTermsCount: action.terms.total_count
            }
        case quesTermTypes.GET_ALL_QUESTION_TERMS_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false
            }
        //Term creation request sending
        case quesTermTypes.CREATE_TERM_REQUEST:
            return {
                ...state,
                errortermcreate: '',
                successtermcreate: false,
                loading: true
            }
        case quesTermTypes.CREATE_TERM_SUCCESS:
            var temp = state.allTerms;
            temp.push(action.terms)
            return {
                ...state,
                allTerms: temp,
                term: action.terms.term_id,
                successtermcreate: true,
                loading: false
            }
        case quesTermTypes.CREATE_TERM_FAILURE:
            return {
                ...state,
                errortermcreate: action.error,
                loading: false
            }  
        //Term deletion request sending   
        case quesTermTypes.DELETE_TERM_REQUEST:
            return {
            ...state,
            errortermdelete: '',
            successtermdelete: false,
            loading: true,
            };
        case quesTermTypes.DELETE_TERM_SUCCESS:
            return {
            ...state,
            successtermdelete: true,
            loading: false,
            };
        case quesTermTypes.DELETE_TERM_FAILURE:
            return {
            ...state,
            errortermdelete: action.error,
            loading: false,
            };
        //Term updation request sending
        case quesTermTypes.UPDATE_TERM_REQUEST:
            return {
            ...state,
            errortermupdate:'',
            successtermupdate: false,
            loading: true,
            };
        case quesTermTypes.UPDATE_TERM_SUCCESS:
            return {
            ...state,
            successtermupdate: true,
            loading: false,
            };
        case quesTermTypes.UPDATE_TERM_FAILURE:
            return {
            ...state,
            errortermupdate: action.error,
            loading: false,
            };     
        default:
            return state
    }
}
